import { useOwnedParkings } from '@repo/domain-service';

export function useDashboardStats() {
  const { ownedParkings, loadingOwnedParkings: loading } = useOwnedParkings(undefined, {
    withSpots: true,
    withCurrentReservations: true,
  });

  const totalParkings = ownedParkings.length;
  const activeParkings = ownedParkings.filter((parking) => parking.status === 'active').length;
  const totalSpots = ownedParkings.reduce((sum, parking) => sum + parking.totalSpots, 0);
  const takenSpots = ownedParkings.reduce((sum, parking) => sum + (parking.totalSpots - parking.availableSpots), 0);
  const availableSpots = ownedParkings.reduce((sum, parking) => sum + parking.availableSpots, 0);

  return {
    loading,
    parkings: ownedParkings,
    totalParkings,
    activeParkings,
    totalSpots,
    takenSpots,
    availableSpots,
  };
}
